module.exports = __webpack_public_path__ + "static/img/3.6107b87.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/avatar/3.png
// module id = F3mb
// module chunks = 1